import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import { lcgApi } from "@/api/lcgApi";
import { REM_CONFIG } from "@/utils/fontSize";
const TotalAssetChange = ({ className = "", }) => {
    const [chartData, setChartData] = useState([]);
    const years = chartData.map((item) => item.year) || [];
    const totalAmounts = chartData.map((item) => item.totalAmount) || [];
    const growthRates = chartData.map((item) => item.growthRate) || [];
    useEffect(() => {
        getData();
    }, []);
    /**
     * @description: getData - 获取数据
     */
    const getData = async () => {
        try {
            const res = await lcgApi.reuseAsset();
            if (res.data) {
                setChartData(res.data);
            }
        }
        catch (error) {
            console.error("获取部门数据失败:", error);
            // 可以设置默认数据或错误处理
        }
    };
    // 🔴 ECharts配置核心调整：年份X轴 + 双轴（数量/变化率）
    const getChartOption = () => ({
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "cross" },
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            borderColor: "#446b9f",
            textStyle: {
                color: "#fff",
            },
        },
        legend: {
            data: ["总量", "变化率"],
            textStyle: { color: "#ffffff", fontSize: REM_CONFIG.fontSize.small },
            orient: "horizontal",
            left: "center",
            top: 8,
            itemGap: 20,
        },
        xAxis: {
            type: "category",
            data: years,
            axisLabel: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
        },
        yAxis: [
            {
                type: "value",
                name: "数量（项）",
                nameTextStyle: {
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
                axisLabel: {
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                    margin: 10,
                },
                splitLine: {
                    lineStyle: { color: "rgba(255,255,255,0.1)", type: "dashed" }, // 网格线浅灰透明
                },
            },
            {
                type: "value",
                name: "变化率",
                nameTextStyle: {
                    color: "#ffffff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
                axisLabel: {
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                    margin: 10,
                    formatter: "{value}%",
                },
                splitLine: { show: false },
            },
        ],
        series: [
            {
                name: "总量",
                type: "bar",
                data: totalAmounts,
                barWidth: "16%",
                itemStyle: {
                    barBorderRadius: [8, 8, 0, 0],
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#2F96E2" },
                        { offset: 1, color: "#1A659B" },
                    ]),
                },
            },
            {
                name: "变化率",
                type: "line",
                yAxisIndex: 1, // 绑定右侧Y轴
                data: growthRates,
                itemStyle: { color: "#60FFFF" },
                symbol: "circle",
                symbolSize: 8,
                smooth: true,
                lineStyle: { width: 2 },
            },
        ],
        grid: {
            left: 10,
            right: 10,
            bottom: 10,
            top: 60,
            containLabel: true,
        },
    });
    return (_jsxs("div", { className: `
        relative
        bg-gradient-to-t
        from-[rgba(7,31,75,0.5)]
        to-[rgba(6,32,66,0.5)]
        backdrop-blur-sm
        flex flex-col
        ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u4F4E\u8017\u603B\u91CF\u53D8\u5316" }), _jsx("div", { className: "flex-1", style: { minHeight: 0 }, children: _jsx(ReactEcharts, { option: getChartOption(), style: { width: "100%", height: "100%" }, echarts: echarts }) })] }));
};
export default TotalAssetChange;
